import { useUncontrolled } from '@mantine/hooks'
import type { Reference } from '@medplum/fhirtypes'
import { Group } from '@seen/core/groups'
import { ExtendedPractitioner } from '@seen/core/models/practitioner'

import { Button, cn } from '@seen/ui'
import type { JSX } from 'react'
import { Combobox } from '#src/components/core/combobox/Combobox.tsx'
import { PractitionerOption } from '#src/components/options/PractitionerOption.tsx'
import { useSearch } from '#src/hooks/useSearch.ts'

type Props = {
  label?: string
  className?: string

  // input props
  onChange?: (value: Reference) => void
  value?: Reference
  defaultValue?: Reference
  error?: any
  onFocus?: any
  onBlur?: any
}

export function SDRIDTPractitionerSelect({
  label,
  className,
  ...inputProps
}: Props): JSX.Element {
  const [value, handleChange] = useUncontrolled<Reference>(inputProps)

  const idtPractitionersQuery = useSearch(
    ExtendedPractitioner,
    ExtendedPractitioner.queryByGroups(Group.IDT)
  )

  const options =
    idtPractitionersQuery.data?.map((practitioner) => ({
      value: practitioner.reference.reference,
      label: <PractitionerOption practitioner={practitioner.reference} />,
      keywords: [practitioner.name],
      entity: practitioner,
    })) ?? []

  const selectedOption = options.find((o) => o.value === value?.reference)

  return (
    <div className={cn('flex flex-col gap-2', className)}>
      {label && <h5>{label}</h5>}
      <Combobox<string>
        options={options}
        onSelect={(reference) => {
          const option = options.find((o) => o.value === reference)
          if (option) {
            handleChange(option.entity.reference)
          }
        }}
        searchPlaceholder="Select practitioner..."
      >
        <Button variant="outline">
          {selectedOption?.label ?? 'Select practitioner...'}
        </Button>
      </Combobox>
    </div>
  )
}
